module.exports = __webpack_public_path__ + "img/top2.0e42b0e5.jpg";